import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { renderIcon } from '@zet/constants/brandDetailsConstants'
import { Stack, XStack } from '@zet/design-system/layout'
import TileTag from '@zet/design-system/tileTag/TileTag'
import { APP_NAME } from '@zet/end-points'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { i18n } from '@zet/localization'
import { zetStoreDpandaIds } from '@zet/utils/Constants'
import _ from 'lodash'

const BrandTiles = ({
  brandId,
  variantId,
}: {
  brandId: string | number
  variantId?: string | number
}) => {
  const { navigate } = useNavigation()
  const { data: brandComms } = useBrandDetailsById(brandId || '')
  const brandName = brandComms?.name || ''
  const brandCategory = brandComms?.subCategory || ''
  const brandCategoryId = brandComms?.categoryId || ''
  const renderIconsByApp = [...renderIcon]

  if (APP_NAME === MY_TEAMS_ADVISOR) {
    _.remove(
      renderIconsByApp,
      (icon) => icon.navigationScreen === 'BrandTrainings'
    )
  }

  if (brandId === zetStoreDpandaIds.partnerId) {
    _.remove(
      renderIconsByApp,
      (icon) => icon.navigationScreen === 'BrandTrainings'
    )
    _.remove(
      renderIconsByApp,
      (icon) => icon.navigationScreen === 'EligibilityCriteria'
    )
  }

  return (
    <Stack className="border-grays-5 mt-[1] border-y-4 bg-white pb-4">
      <XStack>
        {renderIconsByApp.map(
          (value, index) =>
            index < 3 && (
              <TileTag
                key={value.id}
                CardIcon={value.iconName}
                cardName={
                  Boolean(variantId) && brandCategoryId === 15 && index === 0
                    ? i18n.t('customerCategories.brandBenefitsNew')
                    : i18n.t(value.title)
                }
                textClass="-mt-3"
                onPress={() => {
                  navigate(value.navigationScreen, {
                    brandId,
                    variantId,
                    brandCategoryId,
                  })
                }}
                eventName="click_action"
                eventPayload={{
                  item_name: 'brands_list_brand_card',
                  brand_tile: i18n.t(value.title),
                  brand_name: brandName,
                  brand_category: brandCategory,
                }}
              />
            )
        )}
      </XStack>
      <Stack className="h-3" />
      <XStack>
        {renderIconsByApp.map(
          (value, index) =>
            index > 2 && (
              <TileTag
                key={value.id}
                CardIcon={value.iconName}
                cardName={i18n.t(value.title)}
                textClass="-mt-3"
                onPress={() => {
                  navigate(value.navigationScreen, { brandId, variantId })
                }}
                eventName="click_action"
                eventPayload={{
                  item_name: 'brands_list_brand_card',
                  brand_tile: i18n.t(value.title),
                  brand_name: brandName,
                  brand_category: brandCategory,
                }}
              />
            )
        )}
      </XStack>
    </Stack>
  )
}

export default BrandTiles
